(function() {
  const orders = document.querySelector('#orders')
  const home = document.querySelector('#home')
  const orderMenu = document.querySelector('#order-menu');
  const homeMenu = document.querySelector('#home-menu');

  if (window.location.hash === '#orders') {
    showOrders();
  }

  orderMenu.addEventListener('click', (e) => {
    if (window.location.hash === '') {
      window.history.pushState({}, '', window.location.href + '#orders')
      showOrders();
      e.preventDefault();
    }
  });

  homeMenu.addEventListener('click', (e) => {
    if (window.location.hash === '#orders') {
      window.history.pushState({}, '', window.location.href.replace('#orders', ''))
      showHome();
      e.preventDefault();
    }
  });

  function showOrders() {
    orders.classList.remove('hidden');
    home.classList.add('hidden');
    orderMenu.classList.add('customer__menu-item--active');
    homeMenu.classList.remove('customer__menu-item--active');
  }

  function showHome() {
    orders.classList.add('hidden');
    home.classList.remove('hidden');
    orderMenu.classList.remove('customer__menu-item--active');
    homeMenu.classList.add('customer__menu-item--active');
  }

  const menuHeading = document.querySelector('.customer__menu-heading');
  const menuList = document.querySelector('.customer__menu-list');

  menuHeading.addEventListener('click', () => {
    menuList.classList.toggle('customer__menu-list--active') 
  })
})();

async function checkElement (selector) {
  while (document.querySelector(selector) === null) {
      await new Promise(resolve => requestAnimationFrame(resolve))
  }
  return document.querySelector(selector);
}

checkElement('.cf-edit-account-link').then((elem) => {
    const customerMenuList = elem.closest('.customer__menu-list');
    let newItem = document.createElement('li');
    newItem.classList.add('customer__menu-item');
    newItem.appendChild(elem);
    customerMenuList.insertBefore(newItem, customerMenuList.children[2]);
});

const countryModals = document.querySelectorAll('x-modal[data-countries]');
const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

if(countryModals) {

  countryModals.forEach(function(modal) {
    const dataCountries = modal.dataset.countries;
    const countriesArray = dataCountries.split(',');
    const translatedCountriesArray = countriesArray.map(isoCode => {
      return regionNames.of(isoCode) || isoCode;  // Fallback to ISO code if no translation found
    });
    const translatedCountriesString = translatedCountriesArray.join(', ');
    const countrySelector = modal.querySelectorAll('country-selector select option');
    if(countrySelector){
      
      countrySelector.forEach(option => {
        if (!translatedCountriesString.toLowerCase().includes(option.value.toLowerCase())) {
          if(!option.value.includes("--")) {
            option.remove();
          }
        }
              
        if(option.value.includes("--")) {
          option.disabled = true;
          option.value = ""
        }

      });
    }

  });
}
